function toPrecise(num) {
  return Number.parseFloat(num.toFixed(1))
}

function getHeaderEntryHeight(entry) {
  const borderBox = Array.isArray(entry.borderBoxSize)
    ? entry.borderBoxSize[0]
    : entry.borderBoxSize
  const height = borderBox?.blockSize ?? entry.contentRect.height
  return Number.isFinite(height) ? toPrecise(height) : 0
}

function setHeaderHeight(headerHeight) {
  document.documentElement.style.setProperty(
    '--header-height',
    `${headerHeight}px`
  )
}

let headerResizeObserver = null
let headerTrackingInitialized = false

function observeHeaderElements() {
  const elements = document.querySelectorAll('.layout-header')

  if (!elements.length) {
    headerResizeObserver?.disconnect()
    return
  }

  if (!headerResizeObserver) {
    headerResizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeaderHeight(getHeaderEntryHeight(entry))
      }
    })
  } else {
    headerResizeObserver.disconnect()
  }

  for (const element of elements) {
    headerResizeObserver.observe(element)
  }
}

function ensureHeaderTracking() {
  if (headerTrackingInitialized) {
    return
  }
  headerTrackingInitialized = true

  observeHeaderElements()

  window.addEventListener('pageshow', observeHeaderElements)
  document.addEventListener('shopify:section:load', observeHeaderElements)
  document.addEventListener('shopify:section:unload', observeHeaderElements)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureHeaderTracking, {
    once: true
  })
} else {
  ensureHeaderTracking()
}
